import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { CustomerResponsible } from './customer-responsible.util';

@Injectable({
  providedIn: 'root',
})
export class CustomerResponsibleService {
  constructor(private httpClient: HttpClient) {}

  private base(customerId: string): string {
    return `${API_PATH}customers/${customerId}/responsibles`;
  }

  list(customerId: string): Observable<CustomerResponsible[]> {
    return this.httpClient.get<CustomerResponsible[]>(this.base(customerId));
  }

  create(customerId: string, data: CustomerResponsible): Observable<CustomerResponsible> {
    return this.httpClient.post<CustomerResponsible>(this.base(customerId), data);
  }

  update(
    customerId: string,
    responsibleId: string,
    data: CustomerResponsible
  ): Observable<CustomerResponsible> {
    return this.httpClient.put<CustomerResponsible>(`${this.base(customerId)}/${responsibleId}`, data);
  }

  delete(customerId: string, responsibleId: string): Observable<unknown> {
    return this.httpClient.delete(`${this.base(customerId)}/${responsibleId}`);
  }
}
